<template>
  <div class="page_baoyang">
    <Add
      v-if="showAdd"
      :showType="showType"
      :showData="showData"
      @close="addClose"
    ></Add>
    <div class="list_page" v-else>
      <van-nav-bar
        title="保养记录"
        left-text="返回"
        right-text="新增"
        left-arrow
        @click-left="onClickLeft"
        @click-right="showAddClick(1)"
      />
      <div class="list_box">
        <SList url="/emm/emmUpkeepInfo/pageList" :params="params">
          <template slot-scope="{ row }">
            <van-cell
              value="查看详情"
              :title="row.classificationName"
              is-link
              @click="showAddClick(3, row)"
            >
            </van-cell>
            <div class="other" @click="showAddClick(3, row)">
              <p>
                库点名称：<span>{{ row.warehouseName }}</span>
              </p>
              <p>
                任务名称：<span>{{ row.upkeepName }}</span>
              </p>
              <p>
                保养物资通用名：<span>{{ row.classificationName }}</span>
              </p>
              <p>
                保养人：<span>{{ row.operator }}</span>
              </p>
              <p>
                完成保养日期：<span>{{
                  row.completeTime ? row.completeTime.substring(0, 10) : ""
                }}</span>
              </p>
              <p>
                创建时间：<span>{{ row.createTime }}</span>
              </p>
            </div>
          </template>
        </SList>
      </div>
    </div>
  </div>
</template>
<script>
import Add from "./add.vue";
export default {
  components: { Add },
  data() {
    return {
      params: {},
      showAdd: false,
      showType: 1, //0直接新增,1列表新增,2编辑,3查看
      showData: {},
    };
  },
  created() {},
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    showAddClick(type, row) {
      this.showType = type;
      if (type > 1 && row) {
        this.showData = row;
      }
      this.showAdd = true;
    },
    addClose() {
      this.showAdd = false;
    },
  },
};
</script>
<style lang="scss">
.page_baoyang {
  .list_page {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .van-nav-bar {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .list_box {
      width: 100%;
      height: calc(100% - 44px);
      .other {
        background-color: #fff;
        padding: 5px 10px 16px 10px;
        margin-bottom: 10px;
        font-size: 14px;
        p {
          color: rgb(153, 154, 160);
          margin: 5px 0;
          span {
            color: rgb(90, 91, 94);
          }
        }
      }
    }
  }
}
</style>